import React from "react";
import { NavLink } from "react-router-dom";

const Cta = (props) => {
  return (
    <section className="tw-py-16 sm:tw-py-20 tw-bg-white">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Gradient Panel Container */}
        <div className="tw-relative tw-overflow-hidden tw-bg-gradient-to-br tw-from-[#5D44FF] tw-via-indigo-600 tw-to-violet-700 tw-rounded-3xl tw-p-8 sm:tw-p-12 tw-shadow-xl tw-shadow-indigo-500/10 tw-text-center">
          
          {/* Background decorative glow elements */}
          <div className="tw-absolute -tw-top-24 -tw-left-24 tw-w-96 tw-h-96 tw-rounded-full tw-bg-white/10 tw-blur-3xl tw-pointer-events-none" />
          <div className="tw-absolute -tw-bottom-24 -tw-right-24 tw-w-96 tw-h-96 tw-rounded-full tw-bg-violet-900/30 tw-blur-3xl tw-pointer-events-none" />

          {/* Content panel */}
          <div className="tw-relative tw-z-10 tw-max-w-2xl tw-mx-auto">
            <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-white tw-tracking-tight tw-leading-snug tw-mb-8">
              {props.heading}
            </h2>
            <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 tw-justify-center tw-items-center">
              <NavLink
                to={props.firstCta}
                className="tw-w-full sm:tw-w-auto tw-inline-flex tw-items-center tw-justify-center tw-px-7 tw-py-3.5 tw-bg-white hover:tw-bg-slate-50 tw-text-slate-900 tw-font-bold tw-text-sm tw-rounded-xl tw-shadow-md tw-transition-all hover:tw-scale-[1.03]"
              >
                {props.firstCtaText}
              </NavLink>
              <NavLink
                to={props.secondCta}
                className="tw-w-full sm:tw-w-auto tw-inline-flex tw-items-center tw-justify-center tw-px-7 tw-py-3.5 tw-bg-transparent tw-border-2 tw-border-solid tw-border-white hover:tw-bg-white/10 tw-text-white tw-font-bold tw-text-sm tw-rounded-xl tw-transition-all hover:tw-scale-[1.03]"
              >
                {props.secondCtaText}
              </NavLink>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default Cta;
